import { render, staticRenderFns } from "./TrainingQuizQuestion.vue?vue&type=template&id=d84ff6e0&"
import script from "./TrainingQuizQuestion.vue?vue&type=script&lang=js&"
export * from "./TrainingQuizQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports